import { css } from 'styled-components';
import { getSpacing, getTypography, SpacingName, TypographyName } from '../../theme';
export const basic = () => css(["display:flex;align-items:center;"]);
export const box = _ref => {
  let {
    $zIndex
  } = _ref;
  return css(["width:50%;position:relative;", ""], $zIndex && `
    z-index: ${$zIndex};
  `);
};
export const suggestions = _ref2 => {
  let {
    theme
  } = _ref2;
  return css(["position:absolute;top:auto;left:0;right:0;z-index:", ";background-color:", ";border:1px solid ", ";border-top:0;border-radius:0 0 .3rem .3rem;"], theme.zIndex.overlay, theme.palettes.neutrals.lightest, theme.palettes.neutrals.medium);
};
export const suggestion = _ref3 => {
  let {
    theme
  } = _ref3;
  return css(["", " ", " cursor:pointer;&:first-child{", "}&:last-child{", "}&:hover{background-color:", ";}"], getSpacing.padding(theme, [SpacingName.SMALLEST, SpacingName.SMALLER]), getTypography(theme, TypographyName.BODY), getSpacing.marginTop(theme, SpacingName.SMALLEST), getSpacing.marginBottom(theme, SpacingName.SMALLEST), theme.palettes.neutrals.lighter);
};
export const suggestionsScroller = () => css(["overflow-y:auto;max-height:19.5rem;"]);
//# sourceMappingURL=Range.style.js.map